// This file is auto-generated. Do not edit manually.
// Run `yarn tokens:build` to regenerate.
export const tokens = {
  primitives: {
    colors: {
      aqua: {
        '50': 'var(--primitives-colors-aqua-50)',
        '100': 'var(--primitives-colors-aqua-100)',
        '200': 'var(--primitives-colors-aqua-200)',
        '300': 'var(--primitives-colors-aqua-300)',
        '400': 'var(--primitives-colors-aqua-400)',
        '500': 'var(--primitives-colors-aqua-500)',
        '600': 'var(--primitives-colors-aqua-600)',
        '700': 'var(--primitives-colors-aqua-700)',
        '800': 'var(--primitives-colors-aqua-800)',
        '900': 'var(--primitives-colors-aqua-900)',
      },
      blue: {
        '50': 'var(--primitives-colors-blue-50)',
        '100': 'var(--primitives-colors-blue-100)',
        '200': 'var(--primitives-colors-blue-200)',
        '300': 'var(--primitives-colors-blue-300)',
        '400': 'var(--primitives-colors-blue-400)',
        '500': 'var(--primitives-colors-blue-500)',
        '600': 'var(--primitives-colors-blue-600)',
        '700': 'var(--primitives-colors-blue-700)',
        '800': 'var(--primitives-colors-blue-800)',
        '900': 'var(--primitives-colors-blue-900)',
        '1000': 'var(--primitives-colors-blue-1000)',
      },
      constants: {
        black: 'var(--primitives-colors-constants-black)',
        transparent: 'var(--primitives-colors-constants-transparent)',
        white: 'var(--primitives-colors-constants-white)',
      },
      green: {
        '50': 'var(--primitives-colors-green-50)',
        '100': 'var(--primitives-colors-green-100)',
        '200': 'var(--primitives-colors-green-200)',
        '300': 'var(--primitives-colors-green-300)',
        '400': 'var(--primitives-colors-green-400)',
        '500': 'var(--primitives-colors-green-500)',
        '600': 'var(--primitives-colors-green-600)',
        '700': 'var(--primitives-colors-green-700)',
        '800': 'var(--primitives-colors-green-800)',
        '900': 'var(--primitives-colors-green-900)',
        '1000': 'var(--primitives-colors-green-1000)',
      },
      grey: {
        '50': 'var(--primitives-colors-grey-50)',
        '100': 'var(--primitives-colors-grey-100)',
        '125': 'var(--primitives-colors-grey-125)',
        '150': 'var(--primitives-colors-grey-150)',
        '175': 'var(--primitives-colors-grey-175)',
        '200': 'var(--primitives-colors-grey-200)',
        '250': 'var(--primitives-colors-grey-250)',
        '300': 'var(--primitives-colors-grey-300)',
        '400': 'var(--primitives-colors-grey-400)',
        '500': 'var(--primitives-colors-grey-500)',
        '600': 'var(--primitives-colors-grey-600)',
        '700': 'var(--primitives-colors-grey-700)',
        '750': 'var(--primitives-colors-grey-750)',
        '800': 'var(--primitives-colors-grey-800)',
        '850': 'var(--primitives-colors-grey-850)',
        '900': 'var(--primitives-colors-grey-900)',
        '950': 'var(--primitives-colors-grey-950)',
        '1000': 'var(--primitives-colors-grey-1000)',
      },
      indigo: {
        '50': 'var(--primitives-colors-indigo-50)',
        '100': 'var(--primitives-colors-indigo-100)',
        '200': 'var(--primitives-colors-indigo-200)',
        '300': 'var(--primitives-colors-indigo-300)',
        '400': 'var(--primitives-colors-indigo-400)',
        '500': 'var(--primitives-colors-indigo-500)',
        '600': 'var(--primitives-colors-indigo-600)',
        '700': 'var(--primitives-colors-indigo-700)',
        '800': 'var(--primitives-colors-indigo-800)',
        '900': 'var(--primitives-colors-indigo-900)',
      },
      red: {
        '50': 'var(--primitives-colors-red-50)',
        '100': 'var(--primitives-colors-red-100)',
        '200': 'var(--primitives-colors-red-200)',
        '300': 'var(--primitives-colors-red-300)',
        '400': 'var(--primitives-colors-red-400)',
        '500': 'var(--primitives-colors-red-500)',
        '600': 'var(--primitives-colors-red-600)',
        '700': 'var(--primitives-colors-red-700)',
        '800': 'var(--primitives-colors-red-800)',
        '900': 'var(--primitives-colors-red-900)',
      },
      yellow: {
        '50': 'var(--primitives-colors-yellow-50)',
        '100': 'var(--primitives-colors-yellow-100)',
        '200': 'var(--primitives-colors-yellow-200)',
        '300': 'var(--primitives-colors-yellow-300)',
        '400': 'var(--primitives-colors-yellow-400)',
        '500': 'var(--primitives-colors-yellow-500)',
        '600': 'var(--primitives-colors-yellow-600)',
        '700': 'var(--primitives-colors-yellow-700)',
        '800': 'var(--primitives-colors-yellow-800)',
        '900': 'var(--primitives-colors-yellow-900)',
        '1000': 'var(--primitives-colors-yellow-1000)',
        '1100': 'var(--primitives-colors-yellow-1100)',
        '1200': 'var(--primitives-colors-yellow-1200)',
      },
    },
    fontFamily: {
      body: 'var(--tokens-by-app-font-family-body)',
      code: 'var(--tokens-by-app-font-family-code)',
      heading: 'var(--tokens-by-app-font-family-heading)',
      label: 'var(--tokens-by-app-font-family-label)',
      metric: 'var(--tokens-by-app-font-family-metric)',
    },
    space: {
      '025': 'var(--primitives-space-025)',
      '050': 'var(--primitives-space-050)',
      '100': 'var(--primitives-space-100)',
      '200': 'var(--primitives-space-200)',
      '300': 'var(--primitives-space-300)',
      '400': 'var(--primitives-space-400)',
      '500': 'var(--primitives-space-500)',
      '600': 'var(--primitives-space-600)',
      '700': 'var(--primitives-space-700)',
      '800': 'var(--primitives-space-800)',
      '900': 'var(--primitives-space-900)',
    },
    typography: {
      a: {
        '1': {
          fontFamily: 'var(--tokens-by-app-typography-a-1-font-family)',
          fontSize: 'var(--tokens-by-app-typography-a-1-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-a-1-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-a-1-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-a-1-line-height)',
        },
        '2': {
          fontFamily: 'var(--tokens-by-app-typography-a-2-font-family)',
          fontSize: 'var(--tokens-by-app-typography-a-2-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-a-2-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-a-2-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-a-2-line-height)',
        },
        '3': {
          fontFamily: 'var(--tokens-by-app-typography-a-3-font-family)',
          fontSize: 'var(--tokens-by-app-typography-a-3-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-a-3-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-a-3-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-a-3-line-height)',
        },
      },
      c: {
        '12': {
          fontFamily: 'var(--tokens-by-app-typography-c-12-font-family)',
          fontSize: 'var(--tokens-by-app-typography-c-12-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-c-12-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-c-12-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-c-12-line-height)',
        },
        '14': {
          fontFamily: 'var(--tokens-by-app-typography-c-14-font-family)',
          fontSize: 'var(--tokens-by-app-typography-c-14-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-c-14-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-c-14-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-c-14-line-height)',
        },
        '16': {
          fontFamily: 'var(--tokens-by-app-typography-c-16-font-family)',
          fontSize: 'var(--tokens-by-app-typography-c-16-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-c-16-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-c-16-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-c-16-line-height)',
        },
      },
      h: {
        '1': {
          fontFamily: 'var(--tokens-by-app-typography-h-1-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-1-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-1-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-1-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-1-line-height)',
        },
        '2': {
          fontFamily: 'var(--tokens-by-app-typography-h-2-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-2-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-2-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-2-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-2-line-height)',
        },
        '3': {
          fontFamily: 'var(--tokens-by-app-typography-h-3-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-3-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-3-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-3-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-3-line-height)',
        },
        '4': {
          fontFamily: 'var(--tokens-by-app-typography-h-4-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-4-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-4-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-4-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-4-line-height)',
        },
        '5': {
          fontFamily: 'var(--tokens-by-app-typography-h-5-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-5-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-5-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-5-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-5-line-height)',
        },
        '6': {
          fontFamily: 'var(--tokens-by-app-typography-h-6-font-family)',
          fontSize: 'var(--tokens-by-app-typography-h-6-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-h-6-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-h-6-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-h-6-line-height)',
        },
      },
      l: {
        '10B': {
          fontFamily: 'var(--tokens-by-app-typography-l-10-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-10-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-10-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-10-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-10-b-line-height)',
        },
        '10M': {
          fontFamily: 'var(--tokens-by-app-typography-l-10-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-10-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-10-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-10-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-10-m-line-height)',
        },
        '10R': {
          fontFamily: 'var(--tokens-by-app-typography-l-10-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-10-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-10-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-10-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-10-r-line-height)',
        },
        '12B': {
          fontFamily: 'var(--tokens-by-app-typography-l-12-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-12-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-12-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-12-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-12-b-line-height)',
        },
        '12M': {
          fontFamily: 'var(--tokens-by-app-typography-l-12-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-12-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-12-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-12-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-12-m-line-height)',
        },
        '12R': {
          fontFamily: 'var(--tokens-by-app-typography-l-12-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-12-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-12-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-12-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-12-r-line-height)',
        },
        '14B': {
          fontFamily: 'var(--tokens-by-app-typography-l-14-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-14-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-14-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-14-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-14-b-line-height)',
        },
        '14M': {
          fontFamily: 'var(--tokens-by-app-typography-l-14-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-14-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-14-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-14-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-14-m-line-height)',
        },
        '14R': {
          fontFamily: 'var(--tokens-by-app-typography-l-14-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-14-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-14-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-14-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-14-r-line-height)',
        },
        '8M': {
          fontFamily: 'var(--tokens-by-app-typography-l-8-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-l-8-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-l-8-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-l-8-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-l-8-m-line-height)',
        },
      },
      metric: {
        lg: {
          fontFamily: 'var(--tokens-by-app-typography-metric-lg-font-family)',
          fontSize: 'var(--tokens-by-app-typography-metric-lg-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-metric-lg-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-metric-lg-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-metric-lg-line-height)',
        },
        md: {
          fontFamily: 'var(--tokens-by-app-typography-metric-md-font-family)',
          fontSize: 'var(--tokens-by-app-typography-metric-md-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-metric-md-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-metric-md-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-metric-md-line-height)',
        },
        sm: {
          fontFamily: 'var(--tokens-by-app-typography-metric-sm-font-family)',
          fontSize: 'var(--tokens-by-app-typography-metric-sm-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-metric-sm-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-metric-sm-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-metric-sm-line-height)',
        },
        xs: {
          fontFamily: 'var(--tokens-by-app-typography-metric-xs-font-family)',
          fontSize: 'var(--tokens-by-app-typography-metric-xs-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-metric-xs-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-metric-xs-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-metric-xs-line-height)',
        },
      },
      p: {
        '10B': {
          fontFamily: 'var(--tokens-by-app-typography-p-10-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-10-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-10-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-10-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-10-b-line-height)',
        },
        '10M': {
          fontFamily: 'var(--tokens-by-app-typography-p-10-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-10-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-10-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-10-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-10-m-line-height)',
        },
        '10R': {
          fontFamily: 'var(--tokens-by-app-typography-p-10-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-10-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-10-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-10-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-10-r-line-height)',
        },
        '12B': {
          fontFamily: 'var(--tokens-by-app-typography-p-12-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-12-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-12-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-12-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-12-b-line-height)',
        },
        '12M': {
          fontFamily: 'var(--tokens-by-app-typography-p-12-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-12-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-12-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-12-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-12-m-line-height)',
        },
        '12R': {
          fontFamily: 'var(--tokens-by-app-typography-p-12-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-12-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-12-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-12-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-12-r-line-height)',
        },
        '14B': {
          fontFamily: 'var(--tokens-by-app-typography-p-14-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-14-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-14-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-14-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-14-b-line-height)',
        },
        '14M': {
          fontFamily: 'var(--tokens-by-app-typography-p-14-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-14-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-14-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-14-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-14-m-line-height)',
        },
        '14R': {
          fontFamily: 'var(--tokens-by-app-typography-p-14-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-14-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-14-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-14-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-14-r-line-height)',
        },
        '16B': {
          fontFamily: 'var(--tokens-by-app-typography-p-16-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-16-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-16-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-16-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-16-b-line-height)',
        },
        '16M': {
          fontFamily: 'var(--tokens-by-app-typography-p-16-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-16-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-16-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-16-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-16-m-line-height)',
        },
        '16R': {
          fontFamily: 'var(--tokens-by-app-typography-p-16-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-16-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-16-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-16-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-16-r-line-height)',
        },
        '18B': {
          fontFamily: 'var(--tokens-by-app-typography-p-18-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-18-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-18-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-18-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-18-b-line-height)',
        },
        '18M': {
          fontFamily: 'var(--tokens-by-app-typography-p-18-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-18-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-18-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-18-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-18-m-line-height)',
        },
        '18R': {
          fontFamily: 'var(--tokens-by-app-typography-p-18-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-18-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-18-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-18-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-18-r-line-height)',
        },
        '20B': {
          fontFamily: 'var(--tokens-by-app-typography-p-20-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-20-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-20-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-20-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-20-b-line-height)',
        },
        '20M': {
          fontFamily: 'var(--tokens-by-app-typography-p-20-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-20-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-20-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-20-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-20-m-line-height)',
        },
        '20R': {
          fontFamily: 'var(--tokens-by-app-typography-p-20-r-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-20-r-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-20-r-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-20-r-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-20-r-line-height)',
        },
        '40B': {
          fontFamily: 'var(--tokens-by-app-typography-p-40-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-40-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-40-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-40-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-40-b-line-height)',
        },
        '8B': {
          fontFamily: 'var(--tokens-by-app-typography-p-8-b-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-8-b-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-8-b-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-8-b-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-8-b-line-height)',
        },
        '8M': {
          fontFamily: 'var(--tokens-by-app-typography-p-8-m-font-family)',
          fontSize: 'var(--tokens-by-app-typography-p-8-m-font-size)',
          fontWeight: 'var(--tokens-by-app-typography-p-8-m-font-weight)',
          letterSpacing: 'var(--tokens-by-app-typography-p-8-m-letter-spacing)',
          lineHeight: 'var(--tokens-by-app-typography-p-8-m-line-height)',
        },
      },
    },
  },
  theme: {
    bg: {
      action: {
        danger: 'var(--theme-bg-action-danger)',
        dangerActive: 'var(--theme-bg-action-danger-active)',
        dangerHover: 'var(--theme-bg-action-danger-hover)',
        ghostActive: 'var(--theme-bg-action-ghost-active)',
        ghostActiveInverse: 'var(--theme-bg-action-ghost-active-inverse)',
        ghostHover: 'var(--theme-bg-action-ghost-hover)',
        ghostHoverInverse: 'var(--theme-bg-action-ghost-hover-inverse)',
        primary: 'var(--theme-bg-action-primary)',
        primaryActive: 'var(--theme-bg-action-primary-active)',
        primaryHover: 'var(--theme-bg-action-primary-hover)',
        secondary: 'var(--theme-bg-action-secondary)',
        secondaryActive: 'var(--theme-bg-action-secondary-active)',
        secondaryHover: 'var(--theme-bg-action-secondary-hover)',
        surfaceHover: 'var(--theme-bg-action-surface-hover)',
        surfaceStrongActive: 'var(--theme-bg-action-surface-strong-active)',
        surfaceStrongHover: 'var(--theme-bg-action-surface-strong-hover)',
        surfaceSubtleHover: 'var(--theme-bg-action-surface-subtle-hover)',
      },
      categorical: {
        aquaStrong: 'var(--theme-bg-categorical-aqua-strong)',
        aquaSubtle: 'var(--theme-bg-categorical-aqua-subtle)',
        blueStrong: 'var(--theme-bg-categorical-blue-strong)',
        blueSubtle: 'var(--theme-bg-categorical-blue-subtle)',
        greenStrong: 'var(--theme-bg-categorical-green-strong)',
        greenSubtle: 'var(--theme-bg-categorical-green-subtle)',
        greyStrong: 'var(--theme-bg-categorical-grey-strong)',
        greySubtle: 'var(--theme-bg-categorical-grey-subtle)',
        indigoStrong: 'var(--theme-bg-categorical-indigo-strong)',
        indigoSubtle: 'var(--theme-bg-categorical-indigo-subtle)',
        redSubtle: 'var(--theme-bg-categorical-red-subtle)',
        yellowStrong: 'var(--theme-bg-categorical-yellow-strong)',
        yellowSubtle: 'var(--theme-bg-categorical-yellow-subtle)',
      },
      loading: {
        skeleton: 'var(--theme-bg-loading-skeleton)',
        skeletonHighlight: 'var(--theme-bg-loading-skeleton-highlight)',
      },
      selection: {
        error: 'var(--theme-bg-selection-error)',
        errorActive: 'var(--theme-bg-selection-error-active)',
        errorHover: 'var(--theme-bg-selection-error-hover)',
        neutral: 'var(--theme-bg-selection-neutral)',
        neutralActive: 'var(--theme-bg-selection-neutral-active)',
        neutralHover: 'var(--theme-bg-selection-neutral-hover)',
        primary: 'var(--theme-bg-selection-primary)',
        primaryActive: 'var(--theme-bg-selection-primary-active)',
        primaryHover: 'var(--theme-bg-selection-primary-hover)',
        primarySubtle: 'var(--theme-bg-selection-primary-subtle)',
        primarySubtleHover: 'var(--theme-bg-selection-primary-subtle-hover)',
        secondary: 'var(--theme-bg-selection-secondary)',
        secondaryActive: 'var(--theme-bg-selection-secondary-active)',
        secondaryHover: 'var(--theme-bg-selection-secondary-hover)',
        secondarySubtle: 'var(--theme-bg-selection-secondary-subtle)',
        secondarySubtleHover: 'var(--theme-bg-selection-secondary-subtle-hover)',
        surface: 'var(--theme-bg-selection-surface)',
      },
      status: {
        discoverySubtle: 'var(--theme-bg-status-discovery-subtle)',
        errorStrong: 'var(--theme-bg-status-error-strong)',
        errorSubtle: 'var(--theme-bg-status-error-subtle)',
        infoStrong: 'var(--theme-bg-status-info-strong)',
        infoSubtle: 'var(--theme-bg-status-info-subtle)',
        neutralStrong: 'var(--theme-bg-status-neutral-strong)',
        neutralSubtle: 'var(--theme-bg-status-neutral-subtle)',
        successStrong: 'var(--theme-bg-status-success-strong)',
        successSubtle: 'var(--theme-bg-status-success-subtle)',
        warningStrong: 'var(--theme-bg-status-warning-strong)',
        warningSubtle: 'var(--theme-bg-status-warning-subtle)',
      },
      structural: {
        code: 'var(--theme-bg-structural-code)',
        overlay: 'var(--theme-bg-structural-overlay)',
        overlayLight: 'var(--theme-bg-structural-overlay-light)',
        page: 'var(--theme-bg-structural-page)',
        surface: 'var(--theme-bg-structural-surface)',
        surfaceInverse: 'var(--theme-bg-structural-surface-inverse)',
        surfaceRaised: 'var(--theme-bg-structural-surface-raised)',
        surfaceStrong: 'var(--theme-bg-structural-surface-strong)',
        surfaceSubtle: 'var(--theme-bg-structural-surface-subtle)',
      },
    },
    border: {
      action: {
        ghostActive: 'var(--theme-border-action-ghost-active)',
        ghostActiveInverse: 'var(--theme-border-action-ghost-active-inverse)',
        ghostHover: 'var(--theme-border-action-ghost-hover)',
        ghostHoverInverse: 'var(--theme-border-action-ghost-hover-inverse)',
        neutralHover: 'var(--theme-border-action-neutral-hover)',
        secondaryActive: 'var(--theme-border-action-secondary-active)',
      },
      focus: 'var(--theme-border-focus)',
      selection: {
        errorHover: 'var(--theme-border-selection-error-hover)',
        neutralHover: 'var(--theme-border-selection-neutral-hover)',
        neutralSubtle: 'var(--theme-border-selection-neutral-subtle)',
        primary: 'var(--theme-border-selection-primary)',
        primaryHover: 'var(--theme-border-selection-primary-hover)',
        secondary: 'var(--theme-border-selection-secondary)',
        secondaryHover: 'var(--theme-border-selection-secondary-hover)',
      },
      status: {
        discovery: 'var(--theme-border-status-discovery)',
        discoverySubtle: 'var(--theme-border-status-discovery-subtle)',
        error: 'var(--theme-border-status-error)',
        errorSubtle: 'var(--theme-border-status-error-subtle)',
        info: 'var(--theme-border-status-info)',
        infoSubtle: 'var(--theme-border-status-info-subtle)',
        neutral: 'var(--theme-border-status-neutral)',
        neutralSubtle: 'var(--theme-border-status-neutral-subtle)',
        success: 'var(--theme-border-status-success)',
        successSubtle: 'var(--theme-border-status-success-subtle)',
        warning: 'var(--theme-border-status-warning)',
        warningSubtle: 'var(--theme-border-status-warning-subtle)',
      },
      structural: {
        inverse: 'var(--theme-border-structural-inverse)',
        neutral: 'var(--theme-border-structural-neutral)',
        neutralStrong: 'var(--theme-border-structural-neutral-strong)',
        neutralSubtle: 'var(--theme-border-structural-neutral-subtle)',
      },
    },
    data: {
      aqua100: 'var(--theme-data-aqua-100)',
      aqua200: 'var(--theme-data-aqua-200)',
      aqua300: 'var(--theme-data-aqua-300)',
      aqua400: 'var(--theme-data-aqua-400)',
      aqua50: 'var(--theme-data-aqua-50)',
      aqua500: 'var(--theme-data-aqua-500)',
      aqua600: 'var(--theme-data-aqua-600)',
      aqua700: 'var(--theme-data-aqua-700)',
      aqua800: 'var(--theme-data-aqua-800)',
      aqua900: 'var(--theme-data-aqua-900)',
      barchartCursor: 'var(--theme-data-barchart-cursor)',
      blue100: 'var(--theme-data-blue-100)',
      blue200: 'var(--theme-data-blue-200)',
      blue300: 'var(--theme-data-blue-300)',
      blue400: 'var(--theme-data-blue-400)',
      blue50: 'var(--theme-data-blue-50)',
      blue500: 'var(--theme-data-blue-500)',
      blue600: 'var(--theme-data-blue-600)',
      blue700: 'var(--theme-data-blue-700)',
      blue800: 'var(--theme-data-blue-800)',
      blue900: 'var(--theme-data-blue-900)',
      curveCursor300: 'var(--theme-data-curve-cursor-300)',
      curverCursor50: 'var(--theme-data-curver-cursor-50)',
      green100: 'var(--theme-data-green-100)',
      green200: 'var(--theme-data-green-200)',
      green300: 'var(--theme-data-green-300)',
      green400: 'var(--theme-data-green-400)',
      green50: 'var(--theme-data-green-50)',
      green500: 'var(--theme-data-green-500)',
      green600: 'var(--theme-data-green-600)',
      green700: 'var(--theme-data-green-700)',
      green800: 'var(--theme-data-green-800)',
      green900: 'var(--theme-data-green-900)',
      grey100: 'var(--theme-data-grey-100)',
      grey200: 'var(--theme-data-grey-200)',
      grey300: 'var(--theme-data-grey-300)',
      grey400: 'var(--theme-data-grey-400)',
      grey50: 'var(--theme-data-grey-50)',
      grey500: 'var(--theme-data-grey-500)',
      grey600: 'var(--theme-data-grey-600)',
      grey700: 'var(--theme-data-grey-700)',
      grey800: 'var(--theme-data-grey-800)',
      grey900: 'var(--theme-data-grey-900)',
      indigo100: 'var(--theme-data-indigo-100)',
      indigo200: 'var(--theme-data-indigo-200)',
      indigo300: 'var(--theme-data-indigo-300)',
      indigo400: 'var(--theme-data-indigo-400)',
      indigo50: 'var(--theme-data-indigo-50)',
      indigo500: 'var(--theme-data-indigo-500)',
      indigo600: 'var(--theme-data-indigo-600)',
      indigo700: 'var(--theme-data-indigo-700)',
      indigo800: 'var(--theme-data-indigo-800)',
      indigo900: 'var(--theme-data-indigo-900)',
      red100: 'var(--theme-data-red-100)',
      red200: 'var(--theme-data-red-200)',
      red300: 'var(--theme-data-red-300)',
      red400: 'var(--theme-data-red-400)',
      red50: 'var(--theme-data-red-50)',
      red500: 'var(--theme-data-red-500)',
      red600: 'var(--theme-data-red-600)',
      red700: 'var(--theme-data-red-700)',
      red800: 'var(--theme-data-red-800)',
      red900: 'var(--theme-data-red-900)',
      referenceArea: 'var(--theme-data-reference-area)',
      treemapHoverOverlay: 'var(--theme-data-treemap-hover-overlay)',
      yellow100: 'var(--theme-data-yellow-100)',
      yellow200: 'var(--theme-data-yellow-200)',
      yellow300: 'var(--theme-data-yellow-300)',
      yellow400: 'var(--theme-data-yellow-400)',
      yellow50: 'var(--theme-data-yellow-50)',
      yellow500: 'var(--theme-data-yellow-500)',
      yellow600: 'var(--theme-data-yellow-600)',
      yellow700: 'var(--theme-data-yellow-700)',
      yellow800: 'var(--theme-data-yellow-800)',
      yellow900: 'var(--theme-data-yellow-900)',
    },
    disabled: {
      bg: 'var(--theme-disabled-bg)',
      bgStrong: 'var(--theme-disabled-bg-strong)',
      border: 'var(--theme-disabled-border)',
      fg: 'var(--theme-disabled-fg)',
      overlay: 'var(--theme-disabled-overlay)',
      surface: 'var(--theme-disabled-surface)',
    },
    fg: {
      action: {
        danger: 'var(--theme-fg-action-danger)',
        linkNeutral: 'var(--theme-fg-action-link-neutral)',
        linkNeutralHover: 'var(--theme-fg-action-link-neutral-hover)',
        onDanger: 'var(--theme-fg-action-on-danger)',
        onGhost: 'var(--theme-fg-action-on-ghost)',
        onGhostInverse: 'var(--theme-fg-action-on-ghost-inverse)',
        onPrimary: 'var(--theme-fg-action-on-primary)',
        onSecondary: 'var(--theme-fg-action-on-secondary)',
        primary: 'var(--theme-fg-action-primary)',
        primaryActive: 'var(--theme-fg-action-primary-active)',
        primaryHover: 'var(--theme-fg-action-primary-hover)',
      },
      categorical: {
        onAquaStrong: 'var(--theme-fg-categorical-on-aqua-strong)',
        onAquaSubtle: 'var(--theme-fg-categorical-on-aqua-subtle)',
        onBlueStrong: 'var(--theme-fg-categorical-on-blue-strong)',
        onBlueSubtle: 'var(--theme-fg-categorical-on-blue-subtle)',
        onGreenStrong: 'var(--theme-fg-categorical-on-green-strong)',
        onGreenSubtle: 'var(--theme-fg-categorical-on-green-subtle)',
        onGreyStrong: 'var(--theme-fg-categorical-on-grey-strong)',
        onGreySubtle: 'var(--theme-fg-categorical-on-grey-subtle)',
        onIndigoStrong: 'var(--theme-fg-categorical-on-indigo-strong)',
        onIndigoSubtle: 'var(--theme-fg-categorical-on-indigo-subtle)',
        onRedSubtle: 'var(--theme-fg-categorical-on-red-subtle)',
        onYellowStrong: 'var(--theme-fg-categorical-on-yellow-strong)',
        onYellowSubtle: 'var(--theme-fg-categorical-on-yellow-subtle)',
      },
      selection: {
        onError: 'var(--theme-fg-selection-on-error)',
        onNeutral: 'var(--theme-fg-selection-on-neutral)',
        onPriamrySubtle: 'var(--theme-fg-selection-on-priamry-subtle)',
        onPriamrySubtleHover: 'var(--theme-fg-selection-on-priamry-subtle-hover)',
        onPrimary: 'var(--theme-fg-selection-on-primary)',
        onSecondary: 'var(--theme-fg-selection-on-secondary)',
        primary: 'var(--theme-fg-selection-primary)',
        primaryHover: 'var(--theme-fg-selection-primary-hover)',
      },
      status: {
        error: 'var(--theme-fg-status-error)',
        info: 'var(--theme-fg-status-info)',
        neutral: 'var(--theme-fg-status-neutral)',
        onDiscoverySubtle: 'var(--theme-fg-status-on-discovery-subtle)',
        onErrorStrong: 'var(--theme-fg-status-on-error-strong)',
        onErrorStrongInverse: 'var(--theme-fg-status-on-error-strong-inverse)',
        onErrorSubtle: 'var(--theme-fg-status-on-error-subtle)',
        onInfoStrong: 'var(--theme-fg-status-on-info-strong)',
        onInfoStrongInverse: 'var(--theme-fg-status-on-info-strong-inverse)',
        onInfoSubtle: 'var(--theme-fg-status-on-info-subtle)',
        onNeutralStrongInverse: 'var(--theme-fg-status-on-neutral-strong-inverse)',
        onNeutralSubtle: 'var(--theme-fg-status-on-neutral-subtle)',
        onSuccessStrong: 'var(--theme-fg-status-on-success-strong)',
        onSuccessStrongInverse: 'var(--theme-fg-status-on-success-strong-inverse)',
        onSuccessSubtle: 'var(--theme-fg-status-on-success-subtle)',
        onWarningStrong: 'var(--theme-fg-status-on-warning-strong)',
        onWarningStrongInverse: 'var(--theme-fg-status-on-warning-strong-inverse)',
        onWarningSubtle: 'var(--theme-fg-status-on-warning-subtle)',
        success: 'var(--theme-fg-status-success)',
        warning: 'var(--theme-fg-status-warning)',
      },
      structural: {
        primary: 'var(--theme-fg-structural-primary)',
        primaryOnInverse: 'var(--theme-fg-structural-primary-on-inverse)',
        secondary: 'var(--theme-fg-structural-secondary)',
        secondaryOnInverse: 'var(--theme-fg-structural-secondary-on-inverse)',
      },
    },
    gradient: {
      marketingBannerStop1: 'var(--theme-gradient-marketing-banner-stop1)',
      marketingBannerStop2: 'var(--theme-gradient-marketing-banner-stop2)',
      marketingBannerStop3: 'var(--theme-gradient-marketing-banner-stop3)',
      shadowDividerStop1: 'var(--theme-gradient-shadow-divider-stop1)',
      shadowDividerStop2: 'var(--theme-gradient-shadow-divider-stop2)',
    },
    radius: {
      full: 'var(--tokens-by-app-radius-full)',
      lg: 'var(--tokens-by-app-radius-lg)',
      md: 'var(--tokens-by-app-radius-md)',
      sm: 'var(--tokens-by-app-radius-sm)',
      xs: 'var(--tokens-by-app-radius-xs)',
    },
    readonly: {
      bg: 'var(--theme-readonly-bg)',
      fg: 'var(--theme-readonly-fg)',
    },
    shadows: {
      elevation: {
        high: 'var(--theme-shadows-elevation-high)',
        medium: 'var(--theme-shadows-elevation-medium)',
      },
    },
  },
} as const;
